(function () {
    const urlParams = new URLSearchParams(location.search);
    const apts = urlParams.get('apts') || 'royal-portrait';

    var s = document.createElement('script');
    s.src =
        'https://apif.thepawprint.store/snippets/ai_prompt_templates?apts=' + encodeURIComponent(apts);
    // If you need it ASAP, don't defer. If it can wait, set defer=true.
    document.head.appendChild(s);
})();
